import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
let analytics: ReturnType<typeof getAnalytics> | null = null;

export const initializeFirebaseAnalytics = () => {
  try {
    const app = initializeApp(firebaseConfig);
    analytics = getAnalytics(app);
    console.log('Firebase Analytics initialized');
  } catch (error) {
    console.error('Firebase Analytics error:', error);
  }
};

// Track page views
export const trackPageView = (pageName: string) => {
  if (!analytics) return;

  try {
    logEvent(analytics, 'page_view', {
      page_title: pageName,
    });
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};

// Track custom events
export const trackEvent = (eventName: string, eventData?: Record<string, any>) => {
  if (!analytics) return;

  try {
    logEvent(analytics, eventName, eventData);
  } catch (error) {
    console.error('Error tracking event:', error);
  }
};